import { GLOBAL } from "constants/action-types";

export const fetchGlobalProducts = (params = {}) => ({
    payload: params,
    type: GLOBAL.PRODUCTS.FETCH.START,
});

export const fetchNextGlobalProducts = (params = {}) => ({
    payload: params,
    type: GLOBAL.PRODUCTS.FETCH.NEXT,
});

export const resetGlobalProducts = (params = {}) => ({
    payload: params,
    type: GLOBAL.PRODUCTS.RESET,
});
